export default __webpack_public_path__ + "static/flipCardImg-257d7169902b18d9b1edc564b1ec5138.webp";